<ng-container *ngIf="authorized$ | async">
  <ng-container *ngIf="company$ | async as company">
    <mat-toolbar *ngIf="user$ | async as user">
      <button *ngIf="withNavSidebar" mat-icon-button (click)="sidebarMenuClick.emit()" class="menu-toggle nav-sidebar">
        <mat-icon>menu</mat-icon>
      </button>
      <a *ngIf="copilotEnabled$ | async; else legacyHomeLink" routerLink="/signals" class="home-link"
        routerLinkActive="active" [ampTrack]="'nav-td-icon'" [matTooltip]="'header.aiSignals' | translate">
        <img [src]="branding.getLogoGray()" alt="Timedoctor2 Logo" width="32">
        <span class="signals-badge" *ngIf="signalsBadge$ | async as signalsBadge"
          [ngClass]="'signals-badge--' + signalsBadge.sev">
          <mat-icon class="signals-badge__spark" svgIcon="sparkle_filled"></mat-icon>
          <span class="signals-badge__count">{{ signalsBadge.label }}</span>
        </span>
      </a>
      <ng-template #legacyHomeLink>
        <a routerLink="/" class="home-link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
          [ampTrack]="'nav-td-icon'">
          <img [src]="branding.getLogoGray()" alt="Timedoctor2 Logo" width="32">
        </a>
      </ng-template>
      <button *ngIf="!hasMandatoryCall" mat-icon-button (click)="navOpen()" class="menu-toggle hide-gt-1070">
        <div class="header-badge" *ngIf="$any(menuDef)?.sideNavHeaderBadge?.(company, injector)"></div>
        <mat-icon>menu</mat-icon>
      </button>

      <div class="hide-lt-1070" fxFlexAlign="stretch" fxLayout="row" fxLayoutAlign="stretch stretch"
        *ngIf="!hasMandatoryCall">
        <ng-container *ngFor="let item of menuDef.items">
          <ng-container *ngIf="!item.condition || item.condition(company, injector)">
            <ng-container *ngIf="!$any(item).children; else buttonWithChildren">

              <a #menuButton class="toolbar-button stand-alone-btn" [routerLink]="$any(item).routerLink"
                routerLinkActive="active" [ampTrack]="item.ampTrack ?? null">
                <div fxLayout="column" fxLayoutAlign="center center">
                  <ng-container *ngIf="$any(item?.badge) as badgeObj">
                    <ng-container *ngIf="badgeObj.length; else singleBadge">
                      <ng-container *ngFor="let item of badgeObj">
                        <ng-template *ngTemplateOutlet="badgeTemplate; context: { badgeDetail: item }"></ng-template>
                      </ng-container>
                    </ng-container>
                    <ng-template #singleBadge>
                      <ng-template *ngTemplateOutlet="badgeTemplate; context: { badgeDetail: badgeObj }"></ng-template>
                    </ng-template>
                  </ng-container>

                  <ng-template #badgeTemplate let-badgeDetail="badgeDetail">
                    <div class="mini-badge" *ngIf="!badgeDetail.condition || badgeDetail.condition(company, injector)">
                    </div>
                    <ng-template
                      *ngTemplateOutlet="badge; context: { icon: badgeDetail.icon, iconTooltip: badgeDetail.iconTooltip, text: badgeDetail.text, condition: badgeDetail.condition, tooltip: badgeDetail.tooltip }">
                    </ng-template>
                  </ng-template>
                  <span>
                    {{ item.name | translate | uppercase }}
                  </span>
                </div>
              </a>

              <!-- Dynamic notification bubble -->
              <app-callout *ngIf="shouldShowNotificationBubble(item, company)" [origin]="menuButton"
                [title]="getNotificationBubbleTitle(item) | translate"
                [description]="getNotificationBubbleDescription(item) | translate"
                [position]="item.notificationBubble.position || 'top-right'"
                [dismissButtonLabel]="item.notificationBubble.dismissButtonLabel | translate"
                [ctaButtonLabel]="getNotificationBubbleCtaButtonLabel(item) | translate"
                [ctaButtonAction]="item.notificationBubble.ctaButtonAction" [id]="item.notificationBubble.id"
                [timeout]="item.notificationBubble.timeout || 3000"
                [isTracking]="item.notificationBubble.isTracking || false" [panelClass]="'header-notification-bubble'"
                (dismissCallout)="onNotificationBubbleDismiss(item.notificationBubble.id)"
                [saveVisitByDB]="item.notificationBubble.saveVisitByDB || false">
              </app-callout>
            </ng-container>



            <ng-template #buttonWithChildren>
              <button mat-button class="toolbar-button" [matMenuTriggerFor]="subMenu"
                [class.active]="anyChildActive($any(item))" (click)="onMenuButtonClick(item)" [ampTrack]="item.ampTrack ?? null">
                <div class="header-badge" *ngIf="$any(item)?.showHeaderBadgeIcon?.(company, injector)"></div>
                {{ item.name | translate | uppercase }}
                <mat-icon inline>keyboard_arrow_down</mat-icon>
              </button>

              <mat-menu #subMenu="matMenu" [class]="getReportsMenuPanelClass(item)">

                <!-- Grouped Reports Menu for experiment - A/B test - Variant A & B -->
                <ng-container *ngIf="item.name === 'header.reports' && showGroupedReports; else defaultMenuContent">
                  <!-- Variant A: Vertical 1-column layout -->
                  <div *ngIf="reportsMenuGroupingVariant === 'A'" class="reports-menu-variant-a-content">
                    <ng-container *ngFor="let group of groupedReports">
                      <ng-container *ngIf="hasVisibleReports(group, company)">
                        <div class="menu-label">{{ group.name | translate | uppercase }}</div>
                        <ng-container *ngFor="let report of getVisibleReports(group, company)">
                          <a mat-menu-item [routerLink]="$any(report).routerLink" routerLinkActive="active"
                            class="menu-item--min-width" [fragment]="$any(report).fragment"
                            [routerLinkActiveOptions]="$any(report).fragment ? customRouterLinkActiveOptions : {'exact': false}"
                            (click)="onReportItemClick(report, group)" [ampTrack]="$any(report).ampTrack ?? null">
                            {{ report.name | translate }}
                            <ng-container *ngIf="report.badge">
                              <ng-container *ngIf="$any(report.badge).length; else singleReportBadge">
                                <ng-container *ngFor="let badgeItem of $any(report.badge)">
                                  <ng-template
                                    *ngTemplateOutlet="badge; context: { icon: badgeItem.icon, iconTooltip: badgeItem.iconTooltip, text: badgeItem.text, condition: badgeItem.condition, tooltip: badgeItem.tooltip, color: badgeItem.color }"></ng-template>
                                </ng-container>
                              </ng-container>
                              <ng-template #singleReportBadge>
                                <ng-template
                                  *ngTemplateOutlet="badge; context: { icon: $any(report.badge).icon, iconTooltip: $any(report.badge).iconTooltip, text: $any(report.badge).text, condition: $any(report.badge).condition, tooltip: $any(report.badge).tooltip, color: $any(report.badge).color }"></ng-template>
                              </ng-template>
                            </ng-container>
                          </a>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </div>

                  <!-- Variant B: Horizontal 3-column layout -->
                  <div *ngIf="reportsMenuGroupingVariant === 'B'" class="reports-menu-variant-b-content">
                    <!-- Reusable template for rendering a report group -->
                    <ng-template #reportGroupTemplate let-group="group" let-isStacked="isStacked">
                      <ng-container *ngIf="hasVisibleReports(group, company)">
                        <div class="group-header" [class.group-header-stacked]="isStacked">
                          {{ group.name | translate | uppercase }}
                        </div>
                        <ng-container *ngFor="let report of getVisibleReports(group, company)">
                          <a mat-menu-item [routerLink]="$any(report).routerLink" routerLinkActive="active"
                            [fragment]="$any(report).fragment"
                            [routerLinkActiveOptions]="$any(report).fragment ? customRouterLinkActiveOptions : {'exact': false}"
                            (click)="onReportItemClick(report, group)" [ampTrack]="$any(report).ampTrack ?? null">
                            {{ report.name | translate }}
                            <ng-container *ngIf="report.badge">
                              <ng-container *ngIf="$any(report.badge).length; else singleReportBadgeVariantB">
                                <ng-container *ngFor="let badgeItem of $any(report.badge)">
                                  <ng-template
                                    *ngTemplateOutlet="badge; context: { icon: badgeItem.icon, iconTooltip: badgeItem.iconTooltip, text: badgeItem.text, condition: badgeItem.condition, tooltip: badgeItem.tooltip, color: badgeItem.color }"></ng-template>
                                </ng-container>
                              </ng-container>
                              <ng-template #singleReportBadgeVariantB>
                                <ng-template
                                  *ngTemplateOutlet="badge; context: { icon: $any(report.badge).icon, iconTooltip: $any(report.badge).iconTooltip, text: $any(report.badge).text, condition: $any(report.badge).condition, tooltip: $any(report.badge).tooltip, color: $any(report.badge).color }"></ng-template>
                              </ng-template>
                            </ng-container>
                          </a>
                        </ng-container>
                      </ng-container>
                    </ng-template>

                    <div class="reports-mega-menu">
                      <!-- Column 1: Productivity & Focus + Experimental Reports -->
                      <div class="report-group-column">
                        <ng-container
                          *ngTemplateOutlet="reportGroupTemplate; context: { group: getGroupByKey('PRODUCTIVITY_FOCUS'), isStacked: false }"></ng-container>
                        <ng-container
                          *ngTemplateOutlet="reportGroupTemplate; context: { group: getGroupByKey('EXPERIMENTAL'), isStacked: true }"></ng-container>
                      </div>

                      <!-- Column 2: Performance & Collaboration -->
                      <div class="report-group-column" *ngIf="getGroupByKey('PERFORMANCE_COLLABORATION') as perfGroup">
                        <ng-container *ngIf="hasVisibleReports(perfGroup, company)">
                          <ng-container
                            *ngTemplateOutlet="reportGroupTemplate; context: { group: perfGroup, isStacked: false }"></ng-container>
                        </ng-container>
                      </div>

                      <!-- Column 3: Operations & Cost Management -->
                      <div class="report-group-column" *ngIf="getGroupByKey('OPERATIONS_COST') as opsGroup">
                        <ng-container *ngIf="hasVisibleReports(opsGroup, company)">
                          <ng-container
                            *ngTemplateOutlet="reportGroupTemplate; context: { group: opsGroup, isStacked: false }"></ng-container>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <!-- Default menu content (non-grouped or for users not in experiment) -->
                <ng-template #defaultMenuContent>
                  <ng-container *ngFor="let sub of $any(item).children">
                    <ng-container *ngIf="!sub.condition || sub.condition(company, injector)">
                      <ng-container *ngIf="sub.routerLink; else menuLabel">
                        <a mat-menu-item [routerLink]="sub.routerLink" routerLinkActive="active"
                          class="menu-item--min-width" [fragment]="sub.fragment"
                          [routerLinkActiveOptions]="sub.fragment ? customRouterLinkActiveOptions : {'exact': false}"
                          [ampTrack]="$any(sub).ampTrack ?? null">
                          {{ sub.name | translate }}

                          <ng-container *ngIf="sub.badge">
                            <ng-container *ngIf="sub.badge.length; else singleBadge">
                              <ng-container *ngFor="let item of sub.badge">
                                <ng-template
                                  *ngTemplateOutlet="badge; context: { icon: item.icon, iconTooltip: item.iconTooltip, text: item.text, condition: item.condition, tooltip: item.tooltip, color: item.color }"></ng-template>
                              </ng-container>
                            </ng-container>
                            <ng-template #singleBadge>
                              <ng-template
                                *ngTemplateOutlet="badge; context: { icon: sub.badge.icon, iconTooltip: sub.badge.iconTooltip, text: sub.badge.text, condition: sub.badge.condition, tooltip: sub.badge.tooltip, color: sub.badge.color }"></ng-template>
                            </ng-template>
                          </ng-container>
                        </a>
                      </ng-container>
                      <ng-template #menuLabel>
                        <div class="menu-label">{{ sub.name | translate }}</div>
                      </ng-template>
                    </ng-container>
                  </ng-container>
                </ng-template>
              </mat-menu>
            </ng-template>
          </ng-container>
        </ng-container>
      </div>

      <div class="header-actions">
      <button *ngIf="showCelloReferral$ | async" id="cello-referral-button" #celloReferralButton mat-button
        class="cello-referral-button" [style.position]="'relative'" [matTooltip]="'header.referral.tooltip' | translate"
        (click)="openCelloReferral()" [ampTrack]="'nav-referrals'">
        <mat-icon svgIcon="referral_white" *ngIf="celloReferralButtonText"></mat-icon>
        <span class="cello-referral-text">{{ celloReferralButtonText }}</span>
      </button>

      <app-announce-button *ngIf="(isManager$ | async)" [ampTrack]="'nav-bell-icon'"> </app-announce-button>

      <app-copilot-launcher *ngIfFeature="'app-web-copilot'"></app-copilot-launcher>

      <button *ngIf="helpButtonEnabled()" mat-icon-button [matMenuTriggerFor]="helpMenu" class="help-button"
        [ampTrack]="'nav-question-icon'">
        <mat-icon svgIcon="help_outline"></mat-icon>
      </button>

      <app-buy-now-button *ngIf="showBuyNowButton$ | async" [label]="'header.buyNow' | translate"
        (buyNow)="onBuyNow($event)" [trackClick]="{ page: 'Buy Now Button Clicked', location: 'header' }">
      </app-buy-now-button>

      <app-buy-now-button *ngIf="showPaidUpgradeButton$ | async" [label]="'header.upgrade' | translate"
        (buyNow)="onPaidUpgrade($event)" [trackClick]="{ page: 'Upgrade Button Clicked', location: 'header' }"
        [ampTrack]="'action-button'" [ampTrackDetail]="'header-upgrade'">
      </app-buy-now-button>

      <mat-menu #helpMenu="matMenu" xPosition="before" yPosition="below">
        <ng-container *ngIfFeature="'header-help-links'">
          <a *ngFor="let helpLink of getHelpLinks()" mat-menu-item target="_blank" rel="noopener"
            href="{{helpLink.url}}">{{ ('header.help.titles.' + helpLink.title) | translate | titlecase }}</a>
          <mat-divider *ngIf="getHelpLinks().length"></mat-divider>
        </ng-container>
        <ng-container *ngIfFeature="'help-center-link'">
          <a mat-menu-item target="_blank" rel="noopener" href="https://support.timedoctor.com/en/support/home"
            *ngIf="helpCenterEnabled()" [ampTrack]="'nav-help-center'">{{
            'header.help.titles.helpCenter' | translate | titlecase }}</a>
        </ng-container>
        <button mat-menu-item *ngIf="contactUsEnabled()" (click)="openBubbleMessage()" [ampTrack]="'nav-contact-us'">{{
          'header.help.titles.contactUs' | translate | titlecase }}
        </button>
        <a mat-menu-item target="_blank" rel="noopener" href="{{employeePrivacyDisclaimerUrl}}"
          *ngIf="employeePrivacyDisclaimerUrl">{{
          'header.help.titles.employeePrivacyDisclaimer' | translate | titlecase }}</a>
        <a mat-menu-item target="_blank" rel="noopener" href="{{contractorPrivacyDisclaimerUrl}}"
          *ngIf="contractorPrivacyDisclaimerUrl">{{
          'header.help.titles.contractorPrivacyDisclaimer' | translate | titlecase }}</a>
        <a mat-menu-item target="_blank" rel="noopener" [href]="trainingGuideUrl" *ngIf="trainingGuideUrl">{{
          'header.help.titles.trainingGuide' | translate | titlecase }}</a>
      </mat-menu>

      <ng-container *ngIf="(showCompanySelectorInProfileMenu$ | async) !== true">
        <button *ngIf="hasMultipleCompanies; else singleCompanyNavbar" class="toolbar-button ellipsis company-button"
          mat-button [matMenuTriggerFor]="companySelectMenu" [ampTrack]="'nav-company-flyout'">
          <span>{{ company.name }}</span>
        </button>
        <ng-template #singleCompanyNavbar>
          <button class="toolbar-button ellipsis company-button" mat-button [ampTrack]="'nav-company-flyout'">
            <span>{{ company.name }}</span>
          </button>
        </ng-template>
      </ng-container>

      <button #profileButton #profileMenuTrigger="matMenuTrigger" class="toolbar-button ellipsis profile-button"
        mat-button [matMenuTriggerFor]="profileMenu" [ampTrack]="'nav-user-avatar'">
        <span
          *ngIf="(showCompanySelectorInProfileMenu$ | async) !== true && (showCelloReferral$ | async) === false"
          class="user-name" fxHide.xs>{{ user.name }}</span>
        <span #profileCalloutOrigin class="profile-callout-origin">
          <app-avatar [name]="user.name" [size]="32" [textSizeRatio]="32/14"></app-avatar>
        </span>
        <app-badge [dot]="true" dismissId="headerEditProfileImprovedBadgeDot" [trigger]="profileButton"
          [absolute]="true" [top]="'8px'" [right]="'5px'" *ngIf="meetingInsightsMyAccountIntegration$ | async">
        </app-badge>
      </button>

      <!-- Academy notification bubble on profile button -->
      <app-callout #academyCallout [id]="academyCalloutId" *ngIf="showAcademyCallout$ | async"
        [connectedPositions]="profileCalloutPositions" [ctaButtonAction]="onAcademyCalloutDismiss"
        [ctaButtonLabel]="'header.academyCallout.gotIt' | translate"
        [description]="'header.academyCallout.description' | translate" [enableScrollReposition]="true"
        [flexibleDimensions]="false" [isTracking]="false" [origin]="profileCalloutOrigin"
        [panelClass]="'header-notification-bubble academy-profile-callout'" [position]="'top-right'"
        [repositionOnLayoutChange]="true" [saveVisitByDB]="false" [timeout]="0"
        [title]="'header.academyCallout.title' | translate">
      </app-callout>

      <!-- Navattic tutorials moved callout (menu relocation) -->
      <app-callout #tutorialsMovedCallout id="navattic-tutorials-moved-callout"
        *ngIf="showTutorialsMovedCallout$ | async" [connectedPositions]="profileCalloutPositions"
        [ctaButtonAction]="onTutorialsMovedCalloutDismiss" [ctaButtonLabel]="'common.gotIt' | translate"
        [description]="tutorialsMovedCalloutDescription | translate" [enableScrollReposition]="true"
        [flexibleDimensions]="false" [isTracking]="false" [origin]="profileCalloutOrigin"
        [panelClass]="'header-notification-bubble academy-profile-callout'" [position]="'top-right'"
        [repositionOnLayoutChange]="true" [saveVisitByDB]="true" [timeout]="0"
        [title]="tutorialsMovedCalloutTitle | translate">
      </app-callout>

      <!-- Navattic book a call moved callout -->
      <app-callout #bookCallMovedCallout id="navattic-book-call-moved-callout" *ngIf="showBookCallMovedCallout$ | async"
        [connectedPositions]="profileCalloutPositions" [ctaButtonAction]="onBookCallMovedCalloutDismiss"
        [ctaButtonLabel]="'common.gotIt' | translate" [description]="bookCallMovedCalloutDescription | translate"
        [enableScrollReposition]="true" [flexibleDimensions]="false" [isTracking]="false"
        [origin]="profileCalloutOrigin" [panelClass]="'header-notification-bubble academy-profile-callout'"
        [position]="'top-right'" [repositionOnLayoutChange]="true" [saveVisitByDB]="true" [timeout]="0"
        [title]="bookCallMovedCalloutTitle | translate">
      </app-callout>
      </div>

      <mat-menu #profileMenu="matMenu" xPosition="before" yPosition="below" panelClass="profile-menu-panel">
        <ng-container *ngIf="showCompanySelectorInProfileMenu$ | async">
          <div class="profile-menu-identity">
            <div class="profile-menu-identity-user ellipsis">{{ user.name }}</div>
            <div *ngIf="!hasMultipleCompanies" class="profile-menu-identity-company">
              <truncated-text [text]="company.name" position="above"></truncated-text>
            </div>
          </div>
          <div *ngIf="hasMultipleCompanies" mat-menu-item [matMenuTriggerFor]="companySelectMenu"
            class="profile-menu-identity-company profile-menu-identity-company--trigger ellipsis">
            <truncated-text [text]="company.name" position="above"></truncated-text>
          </div>
        </ng-container>
        <div *ngIf="(showCompanySelectorInProfileMenu$ | async) !== true && (showCelloReferral$ | async)"
          class="user-name-menu-item">
          {{ user.name }}
        </div>
        <a #myAccountLink mat-menu-item routerLink="profile-edit" [ampTrack]="'nav-my-account'">
          {{ 'header.editProfile' | translate }}
          <app-badge dismissId="headerEditProfileImprovedBadge" style="margin-left: 8px;" [trigger]="myAccountLink"
            *ngIf="meetingInsightsMyAccountIntegration$ | async">{{ 'common.improved' | translate }}</app-badge>
        </a>
        <a *ngIf="showTimeDoctorAcademyLink$ | async" mat-menu-item [href]="timeDoctorAcademyUrl" target="_blank"
          rel="noopener" class="link-with-badge" [ampTrack]="'nav-time-doctor-academy'"
          [trackClick]="{ page: 'Link Click', linkname: 'Time Doctor Academy', linktype: 'text', linkurl: timeDoctorAcademyUrl, linklocation: 'header' }"
          (click)="onNotificationBubbleDismiss(academyLinkClickedId)">
          {{ 'header.timeDoctorAcademy' | translate }}
          <div *ngIf="showAcademyNewBadge$ | async" class="badge">
            <div class="badge-text">{{ 'common.new' | translate }}</div>
          </div>
        </a>
        <mat-divider *ngIf="showTimeDoctorAcademyLink$ | async"></mat-divider>

        <!-- Navattic relocated menu items (feature flag enabled) -->
        <ng-container *ngIf="(showTakeTourMenuItem$ | async) || (showBookCallMenuItem$ | async)">
          <mat-divider *ngIf="(showTimeDoctorAcademyLink$ | async) === false"></mat-divider>
          <button *ngIf="showTakeTourMenuItem$ | async" mat-menu-item (click)="onTakeTourMenuClick()"
            class="menu-item--min-width" [ampTrack]="'nav-take-a-tour'"
            [trackClick]="{ page: 'Link Click', linkname: 'Take a Tour', linktype: 'text', linkurl: '#', linklocation: 'header' }">
            {{ 'common.takeTour.label' | translate }}
            <div *ngIf="showTakeTourNewBadge$ | async" class="badge menu-item-badge">
              <div class="badge-text">{{ 'common.new' | translate }}</div>
            </div>
          </button>
          <button *ngIf="showBookCallMenuItem$ | async" mat-menu-item (click)="onBookCallMenuClick()"
            class="menu-item--min-width"
            [trackClick]="{ page: 'Link Click', linkname: 'Book a Call', linktype: 'text', linkurl: '#', linklocation: 'header' }">
            {{ 'common.bookCall.label' | translate }}
            <div *ngIf="showBookCallNewBadge$ | async" class="badge menu-item-badge">
              <div class="badge-text">{{ 'common.new' | translate }}</div>
            </div>
          </button>
          <mat-divider></mat-divider>
        </ng-container>

        <button mat-menu-item routerLink="/logout" class="menu-item--min-width" [ampTrack]="'nav-sign-out'">{{ 'header.logout' | translate
          }}</button>
      </mat-menu>

      <mat-menu #companySelectMenu="matMenu" xPosition="before" yPosition="below"
        [overlapTrigger]="!!(showCompanySelectorInProfileMenu$ | async)"
        [class]="(showCompanySelectorInProfileMenu$ | async) ? 'company-select-menu-panel' : ''">
        <ng-container *ngIf="showCompanySelectorInProfileMenu$ | async; else companyMenuNavbarLayout">
          <button *ngFor="let sCompany of companies$ | async" mat-menu-item
            class="menu-item--min-width company-select-menu-item"
            (click)="company !== sCompany && selectCompany(sCompany)" [ampTrack]="'nav-change-company'">
            <mat-icon [style.visibility]="company.id === sCompany.id ? 'visible' : 'hidden'">check_outline</mat-icon>
            <truncated-text class="company-select-menu-item__name" [text]="sCompany.name || ''" position="above"></truncated-text>
          </button>
        </ng-container>
        <ng-template #companyMenuNavbarLayout>
          <button *ngFor="let sCompany of companies$ | async" mat-menu-item class="menu-item--min-width"
            (click)="company !== sCompany && selectCompany(sCompany)" [ampTrack]="'nav-change-company'">{{ sCompany.name }}</button>
        </ng-template>
      </mat-menu>
    </mat-toolbar>
    <ng-template #badge let-condition="condition" let-text="text" let-icon="icon" let-iconTooltip="iconTooltip"
      let-tooltip="tooltip" let-color="color">
      <div *ngIf="!condition || condition(company, injector)" [matTooltip]="tooltip | translate"
        class="badge menu-item-badge" [class.beta]="color === 'beta'">
        <mat-icon *ngIf="icon" class="badge-icon" [matTooltip]="iconTooltip | translate">{{ icon
          }}</mat-icon>
        <div *ngIf="text" class="badge-text">{{ text | translate }}</div>
      </div>
    </ng-template>
  </ng-container>
</ng-container>
